document.addEventListener("DOMContentLoaded", () => {
    const navItems     = document.querySelectorAll(".section-nav__item");
    const sections     = document.querySelectorAll(".content-section");
    const activeMarker = document.querySelector(".section-nav__active-marker");
    const navList      = document.querySelector(".section-nav__list");

    // Smoothly scroll the page to the top of the given section
    function scrollToSection(section) {
        const offset    = 120;
        const targetY   = section.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: targetY, behavior: "smooth" });
    }

    // Position the marker so that its top and height match the nav item
    function updateMarkerPosition(item) {
        const itemTop    = item.offsetTop;
        const itemHeight = item.offsetHeight;
        activeMarker.style.transform = `translateY(${itemTop}px)`;
        activeMarker.style.height    = `${itemHeight}px`;
    }

    // Check which section is in view and activate its corresponding nav item
    function updateActiveOnScroll() {
        const triggerHeight = window.innerHeight * 0.3;
        sections.forEach((section, index) => {
            const rect = section.getBoundingClientRect();
            if (rect.top <= triggerHeight && rect.bottom >= triggerHeight) {
                // Remove “active” from all nav items
                navItems.forEach(item => item.classList.remove("active"));
                // Add “active” to the currently visible section’s nav item
                const currentItem = navItems[index];
                currentItem.classList.add("active");
                // Update the marker under that item
                updateMarkerPosition(currentItem);

                // Center the active item within the navList scroll area
                const containerHeight = navList.clientHeight;
                const scrollTarget    = currentItem.offsetTop
                    - (containerHeight / 2 - currentItem.offsetHeight / 2);
                navList.scrollTo({ top: scrollTarget, behavior: "smooth" });
            }
        });
    }

    const landing_page = document.querySelector(".landing-page");
    if(landing_page) {
        //when click on any btn with a href hero, smooth scroll to top
        const hero = document.querySelectorAll("a[href='#hero']");
        if (hero.length > 0) {
            hero.forEach(item => {
                item.addEventListener("click", e => {
                    e.preventDefault();
                    scrollToSection(landing_page);
                });
            });
        }
    }

    // Initialize on load
    if (navItems) {
        // Attach click handlers to each nav item
        navItems.forEach((item, idx) => {
            item.addEventListener("click", e => {
                e.preventDefault();
                scrollToSection(sections[idx]);
                // Immediately switch active class and move the marker
                navItems.forEach(i => i.classList.remove("active"));
                item.classList.add("active");
                updateMarkerPosition(item);
            });
        });

        updateActiveOnScroll();

        // Throttle scroll events via requestAnimationFrame
        let rafId;
        window.addEventListener("scroll", () => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(updateActiveOnScroll);
        });
    }
    console.log("Script loaded");
});
